<template>
    <div>
        <nav class="navbar-light text-left
                    text-smallest font-weight-bold
                    side-nav mr-2 bg-white shadow vh-100" style="width: 115px;">
            <ul class="nav flex-column h-100p text-left">
                    <li class="nav-item">
                        <router-link :to="{name: 'CrewPersonal' }"
                                     tag="a"
                                     class="nav-link text-dark"
                                     :class="{'active': isActiveRoute('CrewPersonal')}"
                                     role="tab"
                                     data-toggle="list"
                        >
                            Personal Information
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'CrewContact' }"
                                     tag="a"
                                     class="nav-link text-dark"
                                     :class="{'active': isActiveRoute('CrewContact')}"
                                     role="tab"
                                     data-toggle="list"
                        >
                            Address & <br />Contact Details
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'CrewEducation' }"
                                     tag="a"
                                     class="nav-link text-dark"
                                     :class="{'active': isActiveRoute('CrewEducation')}"
                                     role="tab"
                                     data-toggle="list"
                        >
                            Education
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'CrewFamily' }"
                                     tag="a"
                                     class="nav-link text-dark"
                                     :class="{'active': isActiveRoute('CrewFamily')}"
                                     role="tab"
                                     data-toggle="list"
                        >
                            Family
                        </router-link>
                    </li>
                </ul>
        </nav>
        <router-view></router-view>
    </div>
</template>

<script>

    import { vueAppMixin } from "@/mixins/vueAppMixin";

    export default {
        name: "Base201",
        mixins: [ vueAppMixin ],

      mounted() {
        // console.log(this.$route.params.id, 'this is this.$route.params.id')
      }

    }
</script>

<style scoped>
    .nav-link.active,.nav-link:hover {
        background-color: #e87c87;
        color: white !important;
    }
</style>
